import { useTheme } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { toast } from 'react-toastify'

import Notification from '@/components/notification'
import { routes } from '@/routes/config'

interface UseNotificationProps {
  text?: React.ReactNode
}

export function useNotification({ text }: UseNotificationProps) {
  const { palette } = useTheme()

  function show() {
    toast(
      ({ closeToast }) => (
        <Notification
          onClose={closeToast}
          icon={
            <CheckCircleIcon
              style={{
                color: palette.primary.dark,
              }}
            />
          }
          footer={
            <a
              href={routes.Activities()}
              target='_blank'
              style={{
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
              }}
              rel='noreferrer'
            >
              Ver calendário
            </a>
          }
        >
          {text}
        </Notification>
      ),
      {
        position: 'bottom-right',
        style: {
          width: '38rem',
          marginLeft: 'auto',
        },
        closeButton: false,
        autoClose: false,
      },
    )
  }

  return [show]
}
